import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../../shared/services/permission.service';
import { ADMIN, USER_DATA } from '../utils/constant';

export const printDocumentGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const userData = JSON.parse(localStorage.getItem(USER_DATA) || '{}');

  if (userData.role === ADMIN) {
    return true;
  }

  const permissionIds =
    (route.data['permissionIds'] as string[] | undefined) ?? [];
  if (
    permissionIds.length === 0 ||
    permissionIds.some((id) => permissionService.hasAccess(id))
  ) {
    return true;
  }

  void router.navigate(['/dashboard/unauthorized'], { replaceUrl: true });
  return false;
};
